// src/components/motion/celebrate.ts
// 祝福演出。canvas-confetti（≈6KB, Three不使用）でブランドの金の粒子バースト。
// prefers-reduced-motion 時は何もしない。
import confetti from 'canvas-confetti';

const GOLD = ['#E4B95B', '#F0CE7E', '#C9A227', '#FFF3D6'];

function prefersReducedMotion(): boolean {
    return (
        typeof window !== 'undefined' &&
        window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    );
}

/** 正解や小さな達成向けの控えめな金バースト。 */
export function celebrateSmall(): void {
    if (prefersReducedMotion()) return;
    confetti({
        particleCount: 40,
        spread: 55,
        startVelocity: 32,
        gravity: 0.9,
        scalar: 0.9,
        ticks: 120,
        origin: { y: 0.7 },
        colors: GOLD,
        disableForReducedMotion: true,
    });
}

/** 結果画面・レベルアップ等の大きな達成向け。左右から金が舞う。 */
export function celebrateBig(): void {
    if (prefersReducedMotion()) return;
    const end = Date.now() + 900;
    const frame = () => {
        confetti({
            particleCount: 6,
            angle: 60,
            spread: 60,
            startVelocity: 45,
            origin: { x: 0, y: 0.8 },
            colors: GOLD,
            disableForReducedMotion: true,
        });
        confetti({
            particleCount: 6,
            angle: 120,
            spread: 60,
            startVelocity: 45,
            origin: { x: 1, y: 0.8 },
            colors: GOLD,
            disableForReducedMotion: true,
        });
        if (Date.now() < end) requestAnimationFrame(frame);
    };
    frame();
}
